<template>
  <div class="cadastro">
    <Button layout="back" @click="router.back()" class="show-s">
      <i class="fa fa-arrow-left"></i> Voltar
    </Button>
    <form
      class="content"
      v-if="!loader"
      onsubmit="return false;"
      @submit="
        PUT_DOCS({
          cnpj: clear(docs.pj.cnpj),
          cpf: clear(cpf || docs.pf.cpf),
          etag: docs.etag,
          retorno: true,
        });
      "
    >
      <div class="title grid-12">
        <i class="fa fa-folder"></i> &nbsp;Documentos
      </div>
      <div class="column section">
        <div class="sub">Dados pessoa jurídica</div>
        <div class="row column-s">
          <div class="grid-2-g grid-5-m grid-12-s label column">
            <label>CNPJ</label>
            <input
              type="text"
              class="input"
              v-model="docs.pj.cnpj"
              v-mask="'##.###.###/####-##'"
              required
            />
          </div>
          <div class="grid-4-g grid-5-m grid-12-s label column">
            <label>Razão Social</label>
            <div>
              {{ docs.pj.razao_social }}
            </div>
          </div>
        </div>
      </div>

      <div class="column section">
        <div class="sub">Dados pessoa física</div>
        <div class="row column-s wrap">
          <div class="grid-3-g grid-12-s grid-5-m label column">
            <label>Nome</label>
            <div>
              {{ docs.pf.nome }}
            </div>
          </div>
          <div class="grid-2-g grid-12-s grid-3-m label column">
            <label>CPF</label>
            <input
              v-if="docs.pf.cpf == null"
              type="text"
              class="input"
              v-model="cpf"
              v-mask="'###.###.###-##'"
              required
            />
            <div v-else>{{ docs.pf.cpf | cpf }}</div>
          </div>
          <div class="grid-2-g grid-12-s grid-3-m label column">
            <label>RG-Emissor-UF</label>
            <div>
              {{ docs.pf.rg }}
            </div>
          </div>

          <div class="grid-2 grid-12-s grid-3-m label column">
            <label>Data Nascimento</label>
            <div>
              {{ docs.pf.dt_nascimento | date }}
            </div>
          </div>
        </div>
      </div>

      <div class="column section">
        <div class="sub">Endereço empresa</div>
        <div class="row wrap">
          <div class="grid-1-g grid-2-m grid-12-s label column">
            <label>CEP</label>
            <div>
              {{ docs.pj.endereco.cep | cep }}
            </div>
          </div>
          <div class="grid-3-g grid-12-s grid-7-m label column">
            <label>Logradouro</label>

            <div>
              {{ docs.pj.endereco.logradouro }}
            </div>
          </div>
          <div class="grid-1-g grid-12-s label column">
            <label>Número</label>
            <div>
              {{ docs.pj.endereco.numero }}
            </div>
          </div>
          <div class="grid-1-g grid-12-s grid-3-m label column">
            <label>Complemento</label>

            <div>
              {{ docs.pj.endereco.complemento }}
            </div>
          </div>
          <div class="grid-2-g grid-12-s grid-3-m label column">
            <label>Bairro</label>

            <div>
              {{ docs.pj.endereco.bairro }}
            </div>
          </div>
          <div class="grid-2-g grid-12-s grid-3-m label column">
            <label>Cidade</label>

            <div>
              {{ docs.pj.endereco.cidade }}
            </div>
          </div>
          <div class="grid-1-g grid-12-s label column">
            <label>Estado</label>

            <div>
              {{ docs.pj.endereco.estado }}
            </div>
          </div>
        </div>
      </div>
      <div class="save row align-center">
        <div class="hide-s hide-m grid">
          <Button layout="white-m-gray" @click="router.back()" type="button">
            <i class="fa fa-arrow-left"></i> Voltar
          </Button>
        </div>
        <div class="grid-12 row justify-end justify-center-s">
          <Button layout="green-go" class="grid-12-s">Salvar</Button>
        </div>
      </div>
    </form>
    <Loader v-else />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Loader from "@/components/Loader";
import Router from "@/router";
import Vue from "vue";
import format from "@/utils/format";
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

export default {
  name: "Documents",
  components: { Button, Loader },
  data() {
    return { loader: true, router: Router, clear: format.clear, cpf: "" };
  },
  methods: {
    ...mapActions("user", ["LOAD_DOCS", "PUT_DOCS"]),
    ...mapActions("general", ["LOAD_CEP"]),
    cep() {
      if (this.docs.cep.length > 9)
        this.LOAD_CEP(this.docs.cep.replace(".", "").replace("-", "")).then(
          (r) => {
            if (r.logradouro) {
              this.docs.pj.endereco.logradouro = r.logradouro;
              this.docs.pj.endereco.bairro = r.bairro;
              this.docs.pj.endereco.cidade = r.localidade;
              this.docs.pj.endereco.estado = r.uf;
            }
          }
        );
    },
  },
  beforeMount() {
    this.LOAD_DOCS().then(() => (this.loader = false));
  },
  computed: {
    ...mapGetters("user", ["user", "docs"]),
  },
};
</script>


<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.cadastro {
  padding: 0px 30px;
  color: $black;
  input,
  select {
    background: $white;
  }

  .content {
    border-radius: 21px;
    background: $white;
    box-shadow: $shadow;
    padding: 32px 35px;

    .title {
      font-size: 26px;
      margin-bottom: 30px;
      color: $blue-4;
      font-weight: bold;
    }

    .sub {
      font-size: 14px;
      padding: 15px 0;
      font-weight: 500;
      color: $supporter-1;
      text-transform: uppercase;
      margin-bottom: 6px;
      @media (max-width: $small) {
        font-size: 17px;
        text-align: center;
      }
    }

    .label {
      color: $gray-6;
      font-size: 13px;
      font-weight: 300;
      margin-bottom: 25px;
      padding-right: 15px;
      select {
        width: 100%;
      }
      div {
        color: $gray-7;
        font-size: 17px;
        font-weight: 500;
        text-transform: capitalize;
        line-height: 42px;
      }
    }
    .save {
      margin-top: 30px;
    }
    .section {
      padding-bottom: 12px;
    }
    button {
      margin-top: 30px;
    }
  }
  .loader {
    left: 50%;
    margin-left: -45px;
    margin-top: 15%;
  }
  @media (max-width: $small) {
    padding: 7px;
  }
}
</style>
